import Security from "../Miscellanous/Security";

export default Security;